export const sidebars = {
    cart: 'cart',
    schedule: 'schedule',
    categories: 'categories'
};

export const SHOW_SIDEBAR = '[SIDEBAR APP] SHOW';
export const HIDE_SIDEBAR = '[SIDEBAR APP] HIDE';
export const TOGGLE_SIDEBAR = '[SIDEBAR APP] TOGGLE';

export function showSidebar(name) {
    return {
        type: SHOW_SIDEBAR,
        payload: name
    }
}

export function hideSidebar() {
    return {
        type: HIDE_SIDEBAR
    }
}

export function toggleSidebar(name) {
    return {
        type: TOGGLE_SIDEBAR,
        payload: name
    }
}